import {Component, Input, OnInit} from '@angular/core';
import {Articolo, ParereTerzi} from "../_Models/articolo";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ArticoliModalComponent} from "../articoli-modal/articoli-modal.component";
import { webSocket } from "rxjs/webSocket";
import {AuthenticationService} from "../authentication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiRestService} from "../api-rest.service";
import {HttpClient} from "@angular/common/http";
import {DatePipe} from "@angular/common";
import {environment} from "../../../environments/environment";
@Component({
  selector: 'app-articolo',
  templateUrl: './articolo.component.html',
  styleUrls: ['./articolo.component.scss']
})
export class ArticoloComponent implements OnInit {
  Articolo : Articolo ;
  stato: string;
  STATO_NIL = 0;
  STATO_IRRICEVIBILE = 1;
  STATO_RITIRATO = 2;
  STATO_DECADUTO = 3;
  STATO_INAMMISSIBILE = 4;
  ESITO_NIL = 0;
  ESITO_APPROVATO = 1;
  ESITO_ASSORBITO = 2;
  ESITO_PRECLUSO = 3;
  ESITO_RESPINTO = 4;
  RED = "#E52421";//#5d2927
  GREEN = "#66B32E";//#42603b
  YELLOW = "#F07F19";//#ab7940
  CYAN = "#6EC6D9";//#446c72
  constructor(
    private modalService: NgbModal,
    private AuthSvc: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private Api: ApiRestService,
    private httpClient: HttpClient
    ) { }


  ngOnInit(): void {
    if(JSON.parse(localStorage.getItem('User')) == undefined) {
      this.close();
      return
    }
    this.ConnectToWS()
    //this.testArticolo()
     //this.stato = this.getLabelParere(this.Articolo);
  }
  scrollAmount(item){
    if(item?.label?.toString()?.length >15)
      return 10;
    return 0;
  }

  ConnectToWS(){
    this.Api.verifyToken().subscribe(data=>{
      if(!data.status)
        this.close()
      else{
        this.refresh();
        //const subject = webSocket({url:`ws://${this.AuthSvc.currentUserValue.synfra_url.replace("http://","").replace("/web","")}/broadcast`, deserializer: msg => JSON.stringify({ msg: msg })});
        const subject = webSocket({
          url: `ws://${this.AuthSvc.currentUserValue.synfra_url.replace("http://","").replace("/web","")}/broadcast`,
          deserializer: ({ data }) => data
        });
        subject.subscribe(
          msg => {
            console.log('message received: ' + msg.toString())
            const messaggio = JSON.parse(msg.toString())
            console.log(msg.toString())
            console.log(messaggio)
            if(messaggio.type == "currentEmendamento")
              this.refresh(messaggio.message)
            if(messaggio.type == "disconnect") {
              this.close();
              subject.complete();
            }
          },error => {
            this.close()
          }, () =>{
            this.close()
          }
        );
        subject.next({type: "whoim", message: {
            im: JSON.parse(localStorage.getItem('User')).device_id,
            idOrgano: JSON.parse(localStorage.getItem('User')).idOrgano,
            currentView: "device"
          }})
      }
    },error=> this.close())

  }
  close(){
    localStorage.removeItem('User');
    this.router.navigate([this.route.snapshot.queryParams[environment.href] || environment.href,])

  }

  decisione(campo: 'esito' | 'stato' | 'accantonato', value?: 0 | 1 | 2 | 3 | 4){
      switch (campo) {
        case "accantonato":
          this.Api.UpdateEmendamento({emendamenti:[this.Articolo?.id], campo: campo, value: value? value : !this.Articolo.accantonato }).subscribe(data=>{
            this.Articolo.accantonato = !this.Articolo.accantonato;
            this.stato = this.getLabelParere(this.Articolo);
          });
          break;
        case "esito":
            this.Api.UpdateEmendamento({emendamenti:[this.Articolo?.id], campo: campo, value: value? (this.Articolo.parere == value ? 0 : value ): !this.Articolo.accantonato }).subscribe(data=>{
              this.Articolo.parere = this.Articolo.parere == value ? 0 : value;
              this.stato = this.getLabelParere(this.Articolo);
            });
          break;
        case "stato":
            this.Api.UpdateEmendamento({emendamenti:[this.Articolo?.id], campo: campo, value: value? (this.Articolo.stato == value ? 0 : value) : !this.Articolo.accantonato }).subscribe(data=>{
              this.Articolo.stato = this.Articolo.stato == value ? 0 : value;
              this.stato = this.getLabelParere(this.Articolo);
            });
          break;
      }
  }
  getlabelrel(val: 0 | 1 | 2 | 3 | 4 | 5 | null ): string {
    switch (val){
      case 1:
        return "FAVOREVOLE";
      case 2:
        return "FAVOREVOLE RIFORMULATO";
      case 3:
        return "RIMESSO";
      case 4:
        return "INVITO AL RITIRO";
      case 5:
        return "CONTRARIO";
      case 0:
        return "";
      case null:
        return "";
    }
  }
  getLabelParere(articolo : Articolo): string {
    if(articolo?.stato == this.STATO_IRRICEVIBILE)
      return "IRRICEVIBILE";
    if(articolo?.stato == this.STATO_RITIRATO)
      return "RITIRATO";
    if(articolo?.stato == this.STATO_DECADUTO)
      return "DECADUTO";
    if(articolo?.stato == this.STATO_INAMMISSIBILE)
      return "INAMMISSIBILE";
    if(articolo?.parere == this.ESITO_APPROVATO)
      return "APPROVATO";
    if(articolo?.parere == this.ESITO_ASSORBITO)
      return "ASSORBITO";
    if(articolo?.parere == this.ESITO_PRECLUSO)
      return "PRECLUSO";
    if(articolo?.parere == this.ESITO_RESPINTO)
      return "RESPINTO";
    return "";
  }
  getColorStato(articolo : Articolo): string {
    if(articolo.stato == this.STATO_IRRICEVIBILE)
      return this.RED;
    if(articolo.stato == this.STATO_RITIRATO)
      return this.RED;
    if(articolo.stato == this.STATO_DECADUTO)
      return this.RED;
    if(articolo.stato == this.STATO_INAMMISSIBILE)
      return this.YELLOW;
    if(articolo.parere == this.ESITO_APPROVATO)
      return this.GREEN;
    if(articolo.parere == this.ESITO_ASSORBITO)
      return this.YELLOW;
    if(articolo.parere == this.ESITO_PRECLUSO)
      return this.CYAN;
    if(articolo.parere == this.ESITO_RESPINTO)
      return this.RED;
    return "";
  }
  getCOLORParere(val: 0 | 1 | 2 | 3 | 4 | 5 | null){
    switch (val){
      case 1:
        return this.GREEN;
      case 5 :
        return this.RED;
      case 3 :
        return this.YELLOW;
      case 4 :
        return this.YELLOW;
      case 2:
        return this.CYAN;
      case  0:
        return "transparent";
    }
  }

  openPopup(){
    const modal = this.modalService.open(ArticoliModalComponent, {
      centered: false,
      backdrop: 'static',
      size: 'xl',
      windowClass: 'custom-class'
    });
  }

  private refresh(message?) {

    if(!message){
      this.Api.GetCurrentEmendamento().subscribe(data=>{
        this.update(data.data);
      })
    }else
      this.update(message);
  }
  private update(id){
    this.Api.GetEmendamento({filter:{id:parseInt(id.toString())}}).subscribe(res =>{
      var data = res.data[0];
      const datepipe: DatePipe = new DatePipe('en-US')
      //let formattedDate = datepipe.transform(new Date(), 'yyyy/MM/dd').replace('/','')
      let formattedDate = `${new Date().getFullYear().toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })}${(new Date().getMonth() +1 ).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })}${new Date().getDate().toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })}`
      console.log(formattedDate)
      this.Articolo = {
        stato: data.stato,
        commissione: res?.prefisso +  data.numeroPdl,//"A.C. 1402",
        rel: "Baldino",
        data: "2022-03-16 09:30",
        titolo: this.getTitle(data) ,//"3.15 - Ceccanti",
        fascicolo: data?.paginaFascicolo,
        parere: data.esito,
        pareri: this.mapPareri(data).concat([
          {Label: 'Governo', Value: data?.parereGoverno },
        ]),
        accantonato: data.accantonato,
        parteAmmissibile: data.parzialmenteInammissibile,
        riform: data.riformulazione,
        id:data.id,
        disabled: data.esito != null && data.esito != 0 && data.seduta.data != "" && data.seduta.data != null && data.seduta.data != formattedDate,
        //provvedimento.tipo
      }
      this.stato = this.getLabelParere(this.Articolo);
    },error=> this.close())
  }

  mapPareri(data){
    var out: ParereTerzi[] = [];
    data?.pareriRelatori?.parereRelatore?.forEach(parere=>{
      out?.push({Label: 'Rel. ' + parere.cognomeNotorieta, Value: parere.parere })
    })
    return out;
  }

  getTitle(data){
    var firmatario = data.firmatari.firmatario
    var len = firmatario.length;
    if(len > 0) {
      if (data.firmatari.tipoProponente == "deputato")
        return data.numeroEmendamento + " - " + firmatario[0].cognomeNotorieta + (firmatario[0]?.omonimo ? firmatario[0]?.nomeNotorieta : "") + (len > 2 ? " ed altri" : (len == 2 ? " e " + firmatario[1]?.cognomeNotorieta + (firmatario[1]?.omonimo ? " " + firmatario[1]?.nomeNotorieta : "") : ""))
      else
        return data?.numeroEmendamento + " - " + data?.firmatari?.value
    }else return data?.numeroEmendamento;
  }

  private testArticolo() {
    this.httpClient.get<any>("assets/emendamento.json").subscribe(data =>{
      this.Articolo = {
        stato: data.stato,
        commissione: data.numeroPdl,//"A.C. 1402",
        rel: "Baldino",
        data: "2022-03-16 09:30",
        titolo: this.getTitle(data) ,//"3.15 - Ceccanti",
        fascicolo: data?.paginaFascicolo,
        parere: data.esito,
        pareri: this.mapPareri(data).concat([
          {Label: 'Governo', Value: data?.parereGoverno },
        ]),
        accantonato: data.accantonato,
        parteAmmissibile: data.parzialmenteInammissibile,
        riform: data.riformulazione,
        id:data.id
      }
      this.stato = this.getLabelParere(this.Articolo);
    })
    // JSON.parse()
  }
}
